import { createAttachmentsApi } from '#/api/platform/attachments';

export const stockReceiptAttachmentsApi = createAttachmentsApi(
  (businessId) => `/ims/stock-receipt/${businessId}/attachments`,
);
